import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { UserDataProvider } from "./context/UserDataContext";
import { ContentProvider } from "./context/ContentContext";
import SmoothScroll from "./components/SmoothScroll";
import Noise from "./components/Noise";
import Splash from "./components/Splash";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import AuthCallback from "./components/AuthCallback";
import Home from "./pages/Home";
import Library from "./pages/Library";
import Curriculums from "./pages/Curriculums";
import CurriculumDetail from "./pages/CurriculumDetail";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import MyLibrary from "./pages/MyLibrary";
import LibraryEntry from "./pages/LibraryEntry";

function AppRouter() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
  }, [location.pathname]);

  return (
    <>
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/library" element={<Library />} />
          <Route path="/library/:id" element={<LibraryEntry />} />
          <Route path="/curriculums" element={<Curriculums />} />
          <Route path="/curriculums/:id" element={<CurriculumDetail />} />
          <Route path="/my-library" element={<MyLibrary />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/auth/google" element={<AuthCallback />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <UserDataProvider>
          <ContentProvider>
          <SmoothScroll>
            <Noise />
            <Splash />
            <Toaster theme="dark" position="bottom-right" />
            <AppRouter />
          </SmoothScroll>
          </ContentProvider>
          </UserDataProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
